<div
  class="min-height-250 position-absolute w-100"
  style="background: linear-gradient(135deg, #0061f2, rgba(105, 0, 199, 0.8))"
></div>
<aside class="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-4"
       id="sidenav-main">
  <app-sidenav [mijnAssist]="true" [menuItems]="menuItems"></app-sidenav>

 
</aside>
<main class="main-content position-relative border-radius-lg">
  <app-navbar [mijnAssist]="true"></app-navbar>
  <div class="container-fluid mb-5 pb-2">
    <div class="row mb-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
